import * as constants from './../constants';

const setDevice = () => {

  // Check for mobile devices
  const isMobileDevice = () => {
    if( navigator.userAgent.match(/Android/i) ||
     navigator.userAgent.match(/webOS/i) ||
     navigator.userAgent.match(/iPhone/i) ||
     navigator.userAgent.match(/iPad/i) ||
     navigator.userAgent.match(/iPod/i)
    ) {
      window.mobileDevice = true;
      constants.body.classList.add('is-mobile');
    } else {
      window.mobileDevice = false;
    } 
  }
  const isBrowser = () => {
    // # Mozilla/5.0 (Windows NT 10.0) AppleWebKit/537.36 (KHTML, like Gecko) \
    // # Chrome/42.0.2311.135 Safari/537.36 Edge/12.10136

    if (window.navigator.userAgent.indexOf("Edge") > -1) {
      document.documentElement.classList.add('Edge');
    }
  }
  isMobileDevice();
  isBrowser();
  
  window.addEventListener("resize", isMobileDevice, true);
  // Check if iOS device
  if( navigator.userAgent.match(/iPhone/i) ||
   navigator.userAgent.match(/iPad/i) ||
   navigator.userAgent.match(/iPod/i) ) { 
    constants.body.classList.add('iosdevice');
  }

  // this method is used to prevent the hover default action on main menu
  var isTouch =  !!("ontouchstart" in window) || window.navigator.msMaxTouchPoints > 0;
  if( !isTouch ){ }

  // hide for the iPhone´s search bar to minimize fixed back with scroll issue
  // /mobi/i.test(navigator.userAgent) && !location.hash && setTimeout(function () {
  //   if (!pageYOffset) window.scrollTo(0, 1);
  // }, 999);

  // fix for bfcache Safari Browser
  var is_safari = navigator.userAgent.indexOf("Safari") > -1;
  if ((is_safari) && (navigator.userAgent.indexOf('Mac')>1) || (/iphone|ipod|ipad.*os 5/gi).test(navigator.appVersion)) {
    window.onpageshow = function(evt) {
      if (evt.persisted) {
        location.reload();
      }
    };
  }

}

export default setDevice;